// extracted by mini-css-extract-plugin
export var headerCell = "_3m-1";
export var loadingSpinnerContainer = "_3m-4";
export var rowWrapper = "_3m-3";
export var standaloneTable = "_3m-5";
export var table = "_3m-0";
export var white = "_3m-2";